import { render } from "./ManEmp.vue?vue&type=template&id=5a64e3e7"
import script from "./ManEmp.vue?vue&type=script&lang=js"
export * from "./ManEmp.vue?vue&type=script&lang=js"

import "./ManEmp.vue?vue&type=style&index=0&id=5a64e3e7&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__